import { styled } from '@/stitches.config';

export const TopNavigationStyled = styled('header', {
  top: '$space-0',
  left: '$space-0',
  width: '$size-full',
  color: '#1d1d1d', // tailwind gray-900 (base color)
  variants: {
    variant: {
      filled: {
        position: 'sticky',
        zIndex: '$header',
      },
      transparent: {
        position: 'fixed',
        zIndex: 1003, // Note: On top of zIndex: 1002 (ProductNavigation)
        transition:
          'background-color 0.3s var(--transition-easing), opacity 0.3s var(--transition-easing)',
        '&.hidden': {
          opacity: 0,
          pointerEvents: 'none',
        },
      },
    },
    showBackground: {
      true: {
        backgroundColor: '$white',
        boxShadow: '$shadow-200',
      },
      false: {},
    },
  },
  defaultVariants: {
    variant: 'filled',
    showBackground: true,
  },
});
